export default "__VITE_ASSET__DXM$GmeR__"